<template>
  <div class="setEmail">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      ref="ruleForm2"
      label-width="100px"
      class="demo-ruleForm"
      v-show="revisionBox"
    >
      <el-form-item label="邮箱：" prop="emil">
        <el-input type="text" v-model="ruleForm2.emil" autocomplete="off" placeholder="请输入您的邮箱"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-input type="text" v-model="ruleForm2.code" autocomplete="off" placeholder="请输入验证码"></el-input>
        <span v-show="sendAuthCode" class="code" @click="getCode">获取验证码</span>
        <span v-show="!sendAuthCode" class="code">{{auth_time}}秒后重新获取</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
      </el-form-item>
    </el-form>
    <div class="setSuccessd textAign ft16" v-show="successBox">
      <img src="../../../../../assets/images/safety/succeed_icon.png">
      <br>设置成功
    </div>
    <div class="setSuccessd textAign ft16" v-show="defeatedBox">
      <img src="../../../../../assets/images/register/fail_icon.png">
      <br>设置失败
    </div>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import {mapMutations} from "vuex";
export default {
  props: {
    message: {}
  },
  data() {
    var validatePass = (rule, value, callback) => {
      var emilReg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (emilReg.test(value)) {
        var params = {
          account: value
        };
        BaseApi.createRpcToken("/user/checkAccount", params)
          .then(data => {
            console.log(data);
            if (data.datas.code == 3001) {
              this.isExist = true;
            } else if (data.datas.code == 3007) {
              this.isExist = false;
            }
            if (this.message.mail != "") {
              if (value === "") {
                callback(new Error("请输入您的邮箱"));
              } else if (!emilReg.test(value)) {
                callback(new Error("您输入的格式不对，请重新输入"));
              } else if (this.message.mail == value) {
                callback(new Error("您绑定的邮箱和当前邮箱一致"));
              } else if (this.isExist == true) {
                callback(new Error("该用户被占用"));
              } else if (this.isExist == false) {
                callback();
              } else {
                callback();
              }
            } else {
              console.log(this.isExist);
              if (value === "") {
                callback(new Error("请输入您的邮箱"));
              } else if (!emilReg.test(value)) {
                callback(new Error("您输入的格式不对，请重新输入"));
              } else if (this.isExist == true) {
                callback(new Error("该用户被占用"));
              } else if (this.isExist == false) {
                callback();
              } else {
                callback();
              }
            }
          })
          .catch(function(e) {
            errorLog(e);
          });
      } else {
        if (!emilReg.test(value)) {
          callback(new Error("您输入的不是邮箱，请重新输入"));
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        emil: "",
        code: ""
      },
      rules2: {
        emil: [{ validator: validatePass, trigger: "blur" }],
        code: [{ validator: validatePass2, trigger: "blur" }]
      },
      sendAuthCode: true,
      auth_time: 0,
      revisionBox: true,
      successBox: false,
      defeatedBox: false,
      isExist: false
    };
  },
  methods: {
    ...mapMutations(['setUpdateUserState', 'setUserInfo']),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var queryStr = {
            email: this.ruleForm2.emil,
            mailCode: this.ruleForm2.code
          };
          BaseApi.createRpcToken("/user/setMail", queryStr, "post").then(
            data => {
              if (data != undefined) {
                if (data.code == "200") {
                  this.revisionBox = false;
                  this.successBox = true;

                  // 更新邮箱
                  const userInfoObj = JSON.parse(sessionStorage.getItem("userInfo"))
                  userInfoObj.person.mail = this.ruleForm2.emil
                  sessionStorage.setItem("userInfo",JSON.stringify(userInfoObj));
                  this.setUserInfo(userInfoObj);

                  setTimeout(() => {
                    this.revisionBox = true;
                    this.successBox = false;
                    this.$refs[formName].resetFields();
                    this.sendAuthCode = true;
                    this.$emit("closeDialog", false);
                    this.$emit("init");
                    // this.$emit("init");
                  }, 2000);
                }
              }
            },
            data => {
              console.log(data);
              //  this.revisionBox=false;
              // this.defeatedBox=true;
              //  setTimeout(()=>{
              //     this.revisionBox=true;
              //       this.sendAuthCode=true;
              //       this.defeatedBox  =false;
              //   },2000)
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      var emilReg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (this.ruleForm2.emil != "") {
        console.log(this.isExist);
        if (!emilReg.test(this.ruleForm2.emil)) {
          this.$refs.ruleForm2.validateField("emil");
          return;
        }
        if (this.isExist == true) {
          return;
        }
        var queryStr = {
          email: this.ruleForm2.emil
        };
        BaseApi.createRpcToken("/common/getBindingEmailCode", queryStr).then(
          data => {
            console.log(data);
          },
          data => {
            console.log(data);
          }
        );
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimer = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timetimer);
          }
        }, 1000);
      } else {
        this.$refs.ruleForm2.validateField("emil");
      }
    }
  },
  created() {}
};
</script>
<style lang="scss">
.setEmail {
  width: 100%;
  height: 210px;
  padding: 0 39px 0 39px;
  box-sizing: border-box;
  display: table;
  position: relative;
  .el-form {
    .el-input {
      float: left;
    }
    .el-input__inner {
      width: 300px;
      height: 30px;
      border-radius: 0;
    }
    .el-form-item__content {
      float: left;
      margin: 0 !important;
      .el-button--primary {
        height: 40px;
        width: 160px;
        margin-left: 100px;
        background: #D81212;
        border: none;
      }
      .el-button--primary:hover {
        background: #a5303d;
      }
    }
    .el-form-item__label {
      width: 70px !important;
      float: left;
      margin: 0;
      font-family: "PingFangSC-Medium";
      font-size: 14px;
      color: #969696;
      text-align: right;
      padding-right: 0;
    }
    .el-form-item:nth-child(2) {
      .el-input__inner {
        width: 180px;
      }
      .el-input {
        width: 180px;
      }
    }
  }
  .setSuccessd {
    width: calc(100% - 78px);
    position: absolute;
    height: 100px;
    top: 50%;
    margin-top: -50px;
    text-align: center;
    color: #505050;
    padding: 0 39px;
    box-sizing: border-box;
    font-family: "PingFangSC-Medium";
  }
  .code {
    display: inline-block;
    width: 110px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #e88078;
    color: #e88078;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>


